import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .grecaptcha-badge {
    display: none !important;
  }
`;
